import React, { ChangeEvent, useState } from 'react';
import Checkbox from '../Checkbox';
import styles from './style.module.scss';

interface CheckboxTextInputProps {
  maxValue: number;
  checked: boolean;
  textInput: string;
  onChange: () => void;
  setTextInput: (value: string) => void;
}

const CheckboxTextInput: React.FC<CheckboxTextInputProps> = ({
  checked, onChange, textInput, setTextInput,
}) => {

  const [textValue, setTextValue] = useState(textInput || '');

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {

    const newValue = e.target.value;
    setTextInput(newValue.toString());
    setTextValue(newValue);

  };

  const [isFocused, setIsFocused] = useState(textInput !== '');

  return (
    <div className={`${checked ? '' : 'disabled'} ${styles.container}`}>
      <Checkbox
        checked={checked}
        onChange={() => onChange()}
        label={'Other'}
      />
      <div className={`${styles['text-input-box-label']} ${isFocused ? styles.focused : ''}`}>
        <input
          className={styles['text-input-box']}
          type="text"
          value={textValue}
          onChange={handleInputChange}
          disabled={!checked}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {

            if (textValue === '') {

              setIsFocused(false);

            }

          }}
        />
      </div>
    </div>
  );

};

export default CheckboxTextInput;
